// extracted by mini-css-extract-plugin
module.exports = {"singleNumber":"SingleNumber_singleNumber__1NBVb","number":"SingleNumber_number__2ORLj","title":"SingleNumber_title__122F5"};